import React from "react";

const AbstractLines = ({ num }) => {
  return num === 2 ? (
    <svg
      width="200"
      height="199"
      viewBox="0 0 200 199"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ stroke: "#000", strokeWidth: "1.5" }}
    >
      <line x1="99.75" y1="3.27835e-08" x2="99.75" y2="77" />
      <line x1="99.75" y1="122" x2="99.75" y2="199" />
      <line x1="199.003" y1="99.7402" x2="122.003" y2="99.7402" />
      <line x1="77.013" y1="99.7402" x2="0.0197054" y2="100.753" />
      <circle cx="100" cy="99" r="9" fill="black" />
      <line x1="116.38" y1="83.0595" x2="139.714" y2="59.725" />
      <line x1="61.2253" y1="138.214" x2="84.5598" y2="114.879" />
      <line x1="117.44" y1="114.879" x2="140.775" y2="138.213" />
      <line x1="62.2857" y1="59.7246" x2="85.6202" y2="83.0591" />
    </svg>
  ) : (
    <svg
      width="330"
      height="330"
      viewBox="0 0 330 330"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ stroke: "#4F4F4F", strokeWidth: "3", strokeLinecap: "round" }}
    >
      <path d="M77.3008 73.0942C47.7692 102.626 43.1558 126.595 54.2234 137.662C65.291 148.73 98.203 133.762 127.735 104.231C144.285 87.6803 153.904 70.4655 149.219 65.7805C144.534 61.0954 127.319 70.7142 110.769 87.2645C81.2369 116.796 66.2691 149.708 77.3367 160.776C88.4044 171.843 121.317 156.876 150.848 127.344C167.399 110.794 177.017 93.579 172.332 88.8937C167.647 84.2086 150.432 93.8274 133.882 110.378C104.35 139.909 89.4375 172.876 100.573 184.012C111.708 195.147 144.676 180.235 174.207 150.703C190.758 134.153 200.376 116.938 195.691 112.253C191.006 107.568 173.792 117.187 157.241 133.737C127.71 163.269 112.741 196.18 123.809 207.248C134.877 218.316 167.788 203.348 197.32 173.816C213.87 157.266 223.49 140.052 218.805 135.366C214.119 130.681 196.904 140.3 180.354 156.85C150.822 186.382 135.855 219.294 146.923 230.362C157.99 241.429 190.902 226.461 220.434 196.929C236.984 180.379 246.603 163.164 241.918 158.48C237.233 153.795 220.018 163.413 203.468 179.963C173.936 209.495 158.968 242.407 170.035 253.474C181.103 264.542 214.015 249.575 243.547 220.043C260.097 203.493 269.716 186.278 265.031 181.593C260.346 176.908 243.131 186.527 226.581 203.077C197.049 232.609 182.136 265.575 193.272 276.711C204.407 287.846 224.564 283.627 254.095 254.096" />
      <line x1="44.4382" y1="40.9022" x2="289.097" y2="285.561" />
    </svg>
  );
};

export default AbstractLines;
